import { Image } from "./image";
import React, { useState, useEffect } from "react";

export const Gallery = (props) => {
  const [lightbox, setLightbox] = useState({ open: false, src: null, title: null });
  useEffect(() => {
    if (!lightbox.open) return;
    const onKey = (e) => {
      if (e.key === "Escape") setLightbox({ open: false, src: null, title: null });
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [lightbox.open]);

  // Prevent background scroll when lightbox is open
  useEffect(() => {
    if (lightbox.open) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = prev;
      };
    }
  }, [lightbox.open]);
  return (
    <div id="portfolio" className="text-center">
      {lightbox.open && (
        <div
          className="lightbox-overlay"
          role="dialog"
          aria-modal="true"
          onClick={(e) => {
            if (e.target === e.currentTarget) setLightbox({ open: false, src: null, title: null });
          }}
        >
          <button
            className="lightbox-close"
            aria-label="Close"
            onClick={() => setLightbox({ open: false, src: null, title: null })}
          >
            ×
          </button>
          <div className="lightbox-content" role="document">
            <img className="lightbox-img" src={lightbox.src} alt={lightbox.title || ""} />
            {lightbox.title ? <div className="lightbox-caption">{lightbox.title}</div> : null}
          </div>
        </div>
      )}
      <div className="container">
        <div className="section-title">
          <h2>{props.labels?.gallery || "Gallery"}</h2>
          {/* <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit duis sed
            dapibus leonec.
          </p> */}
        </div>
        <div className="row">
          <div className="portfolio-items">
            {props.data
              ? props.data.map((d, i) => (
                  <div
                    key={`${d.title}-${i}`}
                    className="col-sm-6 col-md-4 col-lg-4"
                  >
                    <Image
                      title={d.title}
                      largeImage={d.largeImage}
                      smallImage={d.smallImage}
                      onOpen={() =>
                        setLightbox({ open: true, src: d.largeImage, title: d.title })
                      }
                    />
                  </div>
                ))
              : "Loading..."}
          </div>
        </div>
      </div>
    </div>
  );
};
